module.exports = __webpack_public_path__ + "media/images/support/geolocation/geolocation-warning-1-0419edd9e4f63ee0b3e667f84ceb6941.png";